import { IGlobalLocale } from './locale.interface';

export const en: IGlobalLocale = {
  module: {
    menu: {
      0: {
        title: 'Clients', hint: 'Client directory',
      }, 1: {
        title: 'Accounts', hint: 'Account directory',
      }, 2: {
        title: 'Cards', hint: 'Client cards',
      }, 3: {
        title: 'Reports', hint: 'Reports',
      }, 4: {
        title: 'Instructions', hint: 'Instructions',
      }, 5: {
        title: 'Settings', hint: 'Settings',
      }, 6: {
        title: 'Fund Transfer', hint: 'Transfer funds between accounts/cards',
      }, 7: {
        title: 'My Card', hint: 'My card',
      }, 8: {
        title: 'Documents', hint: 'Documents',
      },
    }, login: {
      enterCRM: 'Log in to CRM',
      welcomeText: 'To log in to your personal account, enter your phone number and password or register',
      titleLogin: 'Phone',
      titlePassword: 'Password',
      btnRegister: 'Registration',
      btnForgotPass: 'Forgot password',
      btnEnter: 'Log in',
      btnResendOTP: 'Send SMS with new code',
      btnLogout: 'Log out',
    }, register: {
      registerCRM: 'Registration',
      updateCRM: 'Password change',
      welcomeTextPhone: 'To register your password, please enter your phone number',
      welcomeTextOTP: 'Enter the code you received via SMS to the specified phone number',
      titlePhone: 'Phone',
      titleOTP: 'SMS code',
      titleForPass: 'Enter your new account password',
      btnRegisterPhone: 'Send SMS code',
      btnRegisterOTP: 'Register',
      btnUpdatePassOTP: 'Update data',
      titleEnterPass: 'Enter password',
      titleEnterRePass: 'Confirm password',
      titleRegisterDriver: 'Your phone number "%1%" will be linked to the card "%2%". Confirm this action?',
      titleRegisterDriverSuccess: 'The phone number "%1%" has been successfully linked to the card "%2%". Next, you need to complete the registration.',
    }, clientList: {
      placeholderSearchString: 'Search by name or EDRPOU',
      titleAccounts: 'Accounts',
      titlePage: 'Clients',
      titleID: 'ID',
      titleNameClient: 'Client name',
      titleOKPO: 'EDRPOU',
      titleINN: 'TIN',
      titlePhone: 'Phone',
      titleEmail: 'Email',
      titleAddress: 'Address',
      titleLegalAddress: 'Legal address',
      titleNumContract: 'Contract number',
      titleStatus: 'Client status',
    }, accounts: {
      titleID: 'ID',
      titleRemark: 'Description',
      titleRest: 'Balance',
      titleOverdraft: 'Overdraft',
      titleTotalBalance: 'Available',
      titleTotalBalanceHint: 'Account balance',
      titlePurses: 'Purses',
      titleTotalBalanceWithoutHold: 'Balance',
      titleTotalBalanceWithoutHoldHint: 'Account balance without holds',
      titleCardsQty: 'Cards (quantity)',
      titleCards: 'Cards',
      btnAccountLink: 'Go to accounts',
    }, cards: {
      titleID: 'Card',
      titleVin: 'Car',
      titlePhone: 'Phone',
      titleName: 'Last name, first name',
      titleActiveMobileApp: 'Driver\'s Cabinet',
      titleSetting: 'Settings',
      titleConfirmRenewPin: 'Do you really want to change the current pin?',
      titleShowNewPin: 'New PIN',
      titleBtnSendOtp: 'Send code',
      titleBtnRetrySendOtp: 'Resend code',
      titleBtnSendRegisterLink: 'Send registration link',
      titleCodeFromSMS: 'SMS code',
      titleBtnCommit: 'Confirm the change to the number',
      titlePermitByDayOfTheWeek: 'Permit by day of the week',
      limits: {
        titleBtnAddLimit: 'Add limit',
        titleMoneySchema: 'Currency scheme',
        titleQtySchema: 'Volume scheme',
        titleShortMoneySchema: 'Currency',
        titleShortQtySchema: 'Volume',
        titlePurses: 'Wallets',
        titleSchemaType: 'Scheme',
        titleType: 'Type',
        titleMoneyByDay: 'UAH/Day',
        titleQtyByDay: 'Liters/Day',
        titleMoneyByMonth: 'UAH/Month',
        titleQtyByMonth: 'Liters/Month',
        titleMoneyByOnce: 'UAH/One-time',
        titleQtyByOnce: 'Liters/One-time',
        titleMoneyByWeek: 'UAH/Week',
        titleQtyByWeek: 'Liters/Week',
        titleMoneyOutOfTime: 'UAH for deduction',
        titleQtyOutOfTime: 'Liters for deduction',
        titleBalance: 'Balance',
        titleLimitAmount: 'Limit',
        titleRest: 'Balance',
        newLimit: {
          title: 'Account',
          titleIndividual: 'Individual',
          titleCommon: 'Common',
          titleTypeLimit: 'Limit type',
          titleLimitAmount: 'Amount',
        },
      },
      qr: {
        notExistCard: 'Card does not exist.\n To add a card, link your phone number to the card',
        notMatchResolution: 'Screen resolution does not match, please rotate your phone',
        contextMenu: {
          blocked: 'Blocking',
          confirmBlockedCard: 'Do you really want to block the card?',
          limits: 'View limits',
        },
        status: {
          0: 'Blocked', 1: 'Active',
        },
      },
    }, transfer: {
      titleAccountSource: 'From',
      titleAccountSourceHelper: 'Select from',
      titleAccountDestination: 'To',
      titleAccountDestinationHelper: 'Select to',
      titleTransferButton: 'Perform transfer',
      confirmTransfer: 'Do you really want to perform this transfer?',
    }, reports: {
      titleTrnKind: 'Report type',
      titleDate: 'Date',
      titleCard: 'Card',
      titleNameAZS: 'Gas station',
      titleAddress: 'Gas station address',
      titlePurse: 'Wallet',
      titleQty: 'Quantity',
      titlePrice: 'Price',
      titleSum: 'Amount',
      titleDiscount: 'Discount',
      titleSumWithDiscount: 'Amount with discount',
      titleName: 'Name',
      titleUseFromDate: 'From date',
      titleUseToDate: 'To date',
      titleSubmitXLS: 'Save EXCEL',
      tittleFilterClear: 'Clear',
      titleAll: 'All',
      titleLastTrn: 'Last Transactions',
    }, documents: {
      billing: {
        titleTab: 'Invoices',
        fileName: 'Invoice_from_%1%',
        typeFuel: 'Payment for fuel',
        typeGoods: 'Payment for goods',
        titleBtnCreateInvoice: 'Create invoice',
        titleLoadingFile: 'Generating invoice...',
        titleLoadingFileError: 'Error displaying preview...',
        titleBtnSaveXLSX: 'Save XLSX',
        titleBtnSavePDF: 'Save PDF',
      }, certificates: {
        titleTab: 'Expense Documents', table: {
          type: 'Document Type',
          number: 'Document Number',
          qty: 'Quantity',
          sumWithPDV: 'Amount, UAH with VAT',
          status: 'Status',
        },
      },
    }, setting: {
      titleChangePass: 'Change Password', titleChangeUser: 'Users', titleAddNewUser: 'Add New User', users: {
        titleAccountId: 'ID',
        titleAccountRemark: 'Description',
        titleFio: 'Last Name, First Name',
        titleFirstName: 'First Name',
        titleLastName: 'Last Name',
        titlePhone: 'Phone',
        titleEmail: 'Email',
        titleApiRole: 'Role',
      }, api: {
        titleApi: 'To access the API, use the Creations API key:',
      },

    }, dataGroup: {
      infoClient: 'Client Information',
      accounts: 'Accounts',
      analytics: 'Analytics',
      limits: 'Limits Balance',
      addLimits: 'Add Limit',
      additionalInfo: 'Additional Information',
      analyticInfo: 'Analytics',
    }, common: {
      table: {
        num: '#',
        active: 'Status',
        filter: 'Filter',
        clearFilter: 'Clear Filter',
        emptyRows: 'No rows found',
        setting: 'Settings',
      }, filter: {
        title: 'Filter',
        titleSubmit: 'Apply',
        titleDate: 'Date',
        titleStatus: 'Status',
        titleIsActive: 'Active',
        titleInactive: 'Inactive',
        titleIsBlock: 'Blocked',
        titleBalance: 'Balance',
        titleNumCard: 'Card Number',
        titlePhone: 'Phone',
        titleVIN: 'Car',
        titleFirstName: 'First Name',
        titleLastName: 'Last Name',
        titleFrom: 'From',
        titleTo: 'To',
        titleAccountName: 'Name',
        titleSelectAll: 'Select All',
      }, title: {
        backToClients: 'Back to Client List',
        backToCards: 'Back to Card List',
        backToAccounts: 'Back to Account List',
        titleClientComboBox: 'Client',
        titleAccountComboBox: 'Account',
        titleCards: 'Cards',
        titleDataNotFound: 'Data Not Found',
        titleNotInitialized: 'Not Defined',
        titleOk: 'Ok',
        titleCancel: 'Cancel',
        titlePeriod: 'Period',
        titleDocumentation: 'Documentation',
        titleLinks: 'Links',
        titleSearchStr: 'Search String',
        titleSelected: 'Selected',
        titleNext: 'Next',
        titleBack: 'Back',
        titleCommit: 'Commit',
        titleSum: 'Amount',
        titleOr: 'Or',
        titleCreate: 'Create',
        titleDelete: 'Delete',
        titleOf: 'of',
        titleExecute: 'Execute',
        titleSubmit: 'Save',
        titleReportTooltip: 'Open calendar',
        titleReportLabelCancel: 'Close',
        titleReportLabelInput: 'Period',
        titleReportLabelBtn: 'Choose',
        dateFrom: 'Period from',
        dateTo: 'Period to',
      }, modal: {
        type: {
          info: 'Information',
          success: 'Successful Execution',
          warning: 'Warning',
          error: 'Error',
          confirmation: 'Confirmation',
          default: '',
        }, labelConfirmation: 'Do you really want to delete the row?',
      },
    },
  }, statusClient: {
    0: 'Active', 1: 'Blocked', 2: 'Deleted', 3: 'Moved',
  }, error: {
    1: 'The entered data is not a phone number',
    2: 'Phone number not found',
    3: 'Incorrect OTP',
    4: 'The user has been registered before',
    5: 'User not found',
    6: 'Incorrect password or phone number (email)',
    7: 'Access to the account is blocked',
    8: 'Invalid parameters',
    9: 'Error creating limit',
    10: 'Failed to set a new PIN',
    11: 'The user has been deleted, please contact the administrator',
    12: 'The user has been deactivated, please contact the administrator',
    18: 'Error updating limit',
    101: 'The account does not belong to the client',
    102: 'Insufficient funds',
    1000: 'Unknown error',
    1001: 'User not authorized',
    1002: 'Operation executed successfully',
    1003: 'An error occurred during execution',
    1004: 'Invalid phone number',
    1005: 'Request error',
    1006: 'Request not authorized',
    1007: 'The filled field is not in the correct format',
    1100: 'Authorization data is not provided',
    validation: {
      fieldRequired: 'Field is required',
      fieldErrorEmail: 'Invalid email',
      fieldErrorPhone: 'Invalid phone number',
    },
  },
};
